export const STORAGE_KEY = 'root-m2';
export const API_URL = process.env.REACT_APP_API_URL;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const DEFAULT_AVATAR = 'https://storage.hitract.se/resources/profileAvatar.png';
export const UNSPLASH_ACCESS_KEY = 'Jn0d3f-04F3e2uqANhqyBjcmNH4pHkRGx48kgCYulUw';
export const CLOUDFLARE_TEST_ACCESS_TOKEN = process.env.REACT_APP_CLOUDFLARE_TEST_ACCESS_TOKEN;
export const CLOUDFLARE_TEST_ACCESS_SECRET = process.env.REACT_APP_CLOUDFLARE_TEST_ACCESS_SECRET;

export const SUPPORTED_NOTIFICATIONS = [ "COMMENT", "LIKE" ]

export const REVENUE = {
    XS: '>1 MSEK',
    S: '>5 MSEK',
    M: '>20 MSEK',
    L: '>99 MSEK',
    XL: '>500 MSEK'
};
  
export const EMPLOYEES = {
    XS: '0-1',
    S: '1-9',
    M: '10-49',
    L: '50-249',
    XL: '>250'
};

export const EMPLOYMENT_TYPES = {
    EXTRA: 'constants.employmentTypes.extra',
    FULL_TIME: 'constants.employmentTypes.fullTime',
    INTERNSHIP: 'constants.employmentTypes.internship',
    PART_TIME: 'constants.employmentTypes.partTime',
    SUMMER: 'constants.employmentTypes.summer',
    TRAINEE: 'constants.employmentTypes.trainee',
};

export const HITMANAGER_STATUS = {
    FOUND: 'Hittad',
    CONTACTED: 'Kontaktad',
    INTERVIEWED: 'Intervjuad',
    EMPLOYED: 'Anställd'
};

export const HITACTION_STATUS = {
    NEW: 'Ny',
    ACTIVE: 'Aktiv',
    CLOSED: 'Klar'
}

export const HITMEMBER_STATUS = {
    MEMBER: 'Medlem',
    NOT_MEMBER: 'Ej medlem',
    PENDING_APPROVAL: 'Ej godkänd',
    CANCELLED_REQUEST: 'Användare avbröt förfrågan',
    PENDING_PAYMENT: 'Godkänd, ej betalt',
    PENDING_USER_FEEDBACK: 'Komplettering',
    CANCELLED_EXPIRED: 'Medlemskap gått ut',
    CANCELLED_DECLINED: 'Förfrågan nekad',
    CANCELLED_TERMINATED_BY_HITCLUB: 'Borttagen av hitClub',
    CANCELLED_TERMINATED_BY_USER: 'Användare lämnat hitClub',
    PAID_NOT_MEMBER: 'Förbetalt, ej medlem',
    PRE_PAID_HAS_APP: '',
    PRE_PAID_NO_APP: ''
}